'use client';
import classNames from 'classnames';
import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import gtm from 'eco-design-reliance/gtm';
import { useEffect, useState } from 'react';

export default function NavToggleIconV1({ prefixCls }: { prefixCls: string }) {
    const [openA, setOpenA] = useState(false);
    const classes = classNames(`${prefixCls}-nav-toggle-icon`, {
        [`${prefixCls}-nav-open`]: openA,
    });
    const toggleHandle = () => {
        const openA2 = !openA;
        setOpenA(openA2);
        EcoDesignEventsBus.emit('ef-header-search-close');

        gtm.push({
            event: 'uaEvent',
            event_name: 'top_function',
            button_name: 'navToggle',
            __btn_id1: `${prefixCls}-nav-toggle-icon`,
            __btn_id2: `header-nav-toggle`,
            __btn_type: 'common',
        });
    };
    useEffect(() => {
        EcoDesignEventsBus.on('ef-header-nav-close', () => {
            setOpenA(false);
        });
    }, []);
    return (
        <button className={classes} onClick={toggleHandle} aria-label="toggle menu" data-btn-id="header-nav-toggle">
            <span className={`${prefixCls}-nav-toggle-item ${prefixCls}-nav-toggle-item1`}></span>
            <span className={`${prefixCls}-nav-toggle-item ${prefixCls}-nav-toggle-item2`}></span>
            <span className={`${prefixCls}-nav-toggle-item ${prefixCls}-nav-toggle-item3`}></span>
        </button>
    );
}
